module.exports = __webpack_public_path__ + "static/media/keyboard-hide.27cdd620.svg";